import type { State } from 'state';

export const getShown = (state: State) => state.ui.search.shown;
export const getTerm = (state: State) => state.ui.search.term;
